'use strict';
// Muslim Pro Games SDK — loader.js v1
// Shared loading screen. Built to /sdk/loader.min.js and included by every
// game right after bridge.min.js. Styled by /sdk/loader.css.
//
// Behaviour: inject a gilded 8-point-star overlay on boot, then dismiss once
//   (a) web fonts are ready, (b) window 'load' has fired, and
//   (c) a minimum display time has elapsed — so it never just flashes.
// A hard timeout guarantees it is removed even if load/fonts stall.
// Games may call window.mpGameReady() to dismiss early (still honours MIN).

(function () {
  var MIN  = 500;    // min visible time (ms) — avoids a jarring flash
  var MAX  = 6000;   // hard fallback (ms) — never stick
  var FADE = 380;    // must match the CSS opacity transition

  // Inline SVG: two overlapping rounded squares (an 8-point star / Rub el Hizb)
  // with a gilded gradient, plus a soft halo behind it. No external image, so
  // it's unaffected by the game's CSP img-src.
  var STAR =
    '<svg viewBox="0 0 100 100" aria-hidden="true">' +
      '<defs>' +
        '<linearGradient id="mpGold" x1="0" y1="0" x2="1" y2="1">' +
          '<stop offset="0%" stop-color="#e7c069"/>' +
          '<stop offset="48%" stop-color="#c9962f"/>' +
          '<stop offset="100%" stop-color="#8c601a"/>' +
        '</linearGradient>' +
        '<radialGradient id="mpHalo" cx="50%" cy="50%" r="50%">' +
          '<stop offset="0%" stop-color="#ffe9b0" stop-opacity="0.9"/>' +
          '<stop offset="100%" stop-color="#ffe9b0" stop-opacity="0"/>' +
        '</radialGradient>' +
      '</defs>' +
      '<circle class="mp-loader__halo" cx="50" cy="50" r="46" fill="url(#mpHalo)"/>' +
      '<g class="mp-loader__star" fill="url(#mpGold)">' +
        '<rect x="26" y="26" width="48" height="48" rx="7"/>' +
        '<rect x="26" y="26" width="48" height="48" rx="7" transform="rotate(45 50 50)"/>' +
        '<circle cx="50" cy="50" r="9" fill="#fbf4dc"/>' +
      '</g>' +
    '</svg>';

  var pendingRemoval = null;

  function inject() {
    var existing = document.getElementById('mp-loader');
    if (existing || !document.body) return existing;
    var el = document.createElement('div');
    el.id = 'mp-loader';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-label', 'Loading');
    el.innerHTML =
      '<div class="mp-loader__mark">' + STAR + '</div>' +
      '<div class="mp-loader__word">Muslim Pro</div>';
    document.body.appendChild(el);
    return el;
  }

  // Show the overlay, re-injecting it if it was already dismissed. Reusable
  // mid-session (e.g. while a game fetches a round), so the loading visual is
  // the same gilded star everywhere — boot and in-game alike.
  function show() {
    if (pendingRemoval) { clearTimeout(pendingRemoval); pendingRemoval = null; }
    var el = inject();
    if (el) el.classList.remove('mp-loader--hide');
  }

  // Fade out and remove. Safe to call repeatedly / when already gone.
  function hide() {
    var el = document.getElementById('mp-loader');
    if (!el) return;
    el.classList.add('mp-loader--hide');
    if (pendingRemoval) clearTimeout(pendingRemoval);
    pendingRemoval = setTimeout(function () {
      if (el && el.parentNode) el.parentNode.removeChild(el);
      pendingRemoval = null;
    }, FADE + 80);
  }

  // Public API for games: window.mpLoader.show() / .hide().
  window.mpLoader = { show: show, hide: hide };

  // ── Boot behaviour ──────────────────────────────────────────────────────
  var start  = Date.now();
  var booted = false;

  // Dismiss the boot loader once, after the min-display window has passed.
  function scheduleBootHide() {
    if (booted) return;
    setTimeout(function () {
      if (booted) return;
      booted = true;
      hide();
    }, Math.max(0, MIN - (Date.now() - start)));
  }

  // Optional explicit hook for games that want to dismiss the moment their
  // first screen is painted/populated.
  window.mpGameReady = scheduleBootHide;

  function whenReady() {
    var fonts = (document.fonts && document.fonts.ready)
      ? document.fonts.ready.catch(function () {})
      : Promise.resolve();
    var loaded = (document.readyState === 'complete')
      ? Promise.resolve()
      : new Promise(function (res) {
          window.addEventListener('load', res, { once: true });
        });
    Promise.all([fonts, loaded]).then(scheduleBootHide);
  }

  if (document.body) inject();
  else document.addEventListener('DOMContentLoaded', inject, { once: true });

  whenReady();
  setTimeout(function () {           // hard fallback — never stick on boot
    if (booted) return;
    booted = true;
    hide();
  }, MAX);
})();
